<template>
  <esg-base-chart height="270px">
    <loading :active="loading"
             :z-index="1000"
             :is-full-page="false"/>
    <apex-chart type="donut"
                :width=this.width
                :height=this.height
                ref="chart"
                v-show="!loading"
                :series="series"
                :options="chartOptions"/>
  </esg-base-chart>
</template>
<script>
import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";

export default {
  components: { EsgBaseChart },
  props: {
    businessLocation: {
      type: Object,
      required: true,
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '270'
    }
  },
  data() {
    return {
      loading: false,
      series: [],
      chartOptions: {
        chart: {
          fontFamily: 'NanumGothic, serif',
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              size: '70%',
              labels: { // Number at the center
                show: true,
                value: {
                  show: true,
                  fontSize: 14,
                  formatter: val => this.formatNumber(val, 0) + ' tCO2e'
                },
                total: {
                  show: true,
                  label: '총 배출량',
                  color: 'black',
                  fontSize: 14,
                  formatter: chart => {
                    const total = chart.config.series.reduce((a, b) => a + b, 0);
                    return this.formatNumber(total, 0) + ' tCO2e';
                  }
                },
              },
            },
          },
        },
        dataLabels: {
          enabled: false
        },
        tooltip: {
          show: true,
          y: {
            formatter: val => this.formatNumber(val, 2) + ' tCO2e'
          },
        },
        legend: {
          position: 'bottom',
        },
        title: {
          text: this.businessLocation.name,
          align: "center",
          style: {
            fontSize: '14px',
            fontWeight: 'bold',
          },
        },
        states: {
          active: { filter: { type: 'none', } },
        },
      },
    }
  },
  created() {
    this.fetchData()
  },
  beforeDestroy() {
    if (this.abortController) {
      this.abortController.abort();
    }
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;

        let year = new Date().getFullYear();
        let args = [{
          years: [year],
          scopes: [1, 2, 3],
          corporations: [this.businessLocation.corporation_code],
          businessLocations: [this.businessLocation.business_location_code],
          groupKeys: ['year', 'scope', 'corporation_code', 'business_location_code']
        }];

        let data = new FormData();
        data.append('path', 'esg/ghg_emission/main');
        data.append('json', JSON.stringify(args));

        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: { Authorization: accessToken() }
        });

        // If there is no data, return
        if (!response.data.data) {
          this.series = [];
          return;
        }


        let list = JSON.parse(response.data.data)[0].data

        this.series = list.map(row => row.values);
        this.chartOptions.labels = list.map(obj => `Scope ${obj.scope}`);
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
        this.refreshChart();
      }
    },
  },
}
</script>
